import { PathElementTypes } from '../../../architecture/interfaces/IPathElement';
import { PathElement } from './PathElement';

export class ArrayElement extends PathElement {
  type = PathElementTypes.ArrayElement;
  constructor(public key: number) {
    super(key);
  }
}
